import * as React from 'react'
import { useHistory } from 'react-router-dom';
import axios from 'axios'

//This component allow user who forget is password to set a new one when he comes from the adequate link given by mail.
export const RegenPassword: React.FunctionComponent = (props) => {

    let registerJSON = {}
    let history = useHistory()
    const userId = window.location.href.toString().split('/')[6]
    const passwordToken = window.location.href.toString().split('/')[7]

    const submitRegister= () => {
        axios.post('https://LaurenceBrun.eu.pythonanywhere.com/auth/password/reset/confirm/', registerJSON,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )
        .then(function (response) {
            alert("Votre mot de passe a bien été changé !")
            history.push('/connexion')
        })
        .catch(function(error) {
            alert("Une erreur est survenue ! Veuillez réessayer.")
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        if (event.target.password.value && event.target.passwordRepeat.value) {
            if (event.target.password.value === event.target.passwordRepeat.value) {
                if(event.target.password.value.length < 8) {
                    alert('Votre mot de passe doit faire 8 caractères ou plus !')
                }
                else {
                    registerJSON = {
                        "uid": userId,
                        "token": passwordToken,
                        "new_password1": event.target.password.value,
                        "new_password2": event.target.passwordRepeat.value,
                    }
                    submitRegister()
                }
            }
            else {
                alert("Vous devez saisir deux fois le même mot de passe !")
            }
        }
        else {
            alert('Vous devez remplir tous les champs !')
        } 
    }

    return(
        <div className="Connect">
            <h2>Générer un nouveau mot de passe</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="password" name="password" placeholder="Mot de passe" />                    
                </label><br />
                <label>
                    <input type="password" name="passwordRepeat" placeholder="Répéter mot de passe" />                    
                </label><br />
                <input type="submit" value="enregistrer nouveau mot de passe" className="ConnectButton Connexion" />
            </form>
        </div>
    )
}